// extracted by mini-css-extract-plugin
module.exports = {"container":"_2OWjqYt-Jw8-70YaPC7jXH"};